import styled from 'styled-components';

export const SubTitle = styled.p`
  font-size: 20px;
  text-align: center;
  margin: 15px;
  color: #444444;
`;
